import {AccountBalance, Money, TransferLimit} from "../http/protocol";
import {Big} from "big.js";
import {t} from "../i18n";
import CurrencyFormatter  from "./CurrencyFormatter";

export function toMoneyString(m? : Money, includeCurrency? : boolean) {
    if(!m || !m.amount) {
        return "-";
    }
    return new Big(m.amount).toFixed(m.fractionalDigits) + (includeCurrency ? " " + m.currencyCode  : "");
}

export function withdrawAmountValidCheck(balances:AccountBalance[], currencyCode:string, transferLimits:TransferLimit[]):{minWithdrawValid:boolean, maxWithdrawValid: boolean, message: Big} {
    let amountValidResult = {
        minWithdrawValid: true,
        maxWithdrawValid: true,
        message: new Big(0)
    };

    let tl = transferLimits && transferLimits.filter((tl:TransferLimit) => {
        if(tl.currency == currencyCode) {
            return tl;
        }
    });
    let transferLimit:TransferLimit = tl ? tl[0] : {};


    if(balances) {
        let balance: AccountBalance | undefined;
        balance = balances.find(balance => balance.balance?.currencyCode === currencyCode);

        if(balance&& balance.balance && transferLimit != undefined) {
            if(balance.balance.amount !== undefined) {
                let minWithdraw = transferLimit.minWithdrawAmount && Big(transferLimit.minWithdrawAmount);
                let balanceAmount:Big = new Big(0);
                balances.filter((balance) => {
                    if(balance.balance && balance.balance.amount && balance.balance.currencyCode == currencyCode) {
                        balanceAmount = Big(balance.balance.amount);
                    }
                });
                if(minWithdraw) {
                    if(balanceAmount.lt(minWithdraw)) {
                        amountValidResult.message = minWithdraw;
                        amountValidResult.minWithdrawValid = false;
                    }
                }
            }
        }
    }

    return amountValidResult;
}